<div class="sp-row__space">
  <div class="sp-row__align">
    <mat-icon
      class="sp-color__primary sp-hidden__before-md sp-cursor__pointer"
      (click)="onBackClick()">
      arrow_back
    </mat-icon>
    <h2 class="sp-margin__left sp-color__primary sp-hidden__before-md">{{ getShrinkedID() }}</h2>
    <h3 class="sp-margin__left sp-color__primary sp-hidden__after-md">{{ getShrinkedID() }}</h3>
  </div>

  <div class="sp-row__align">
    <mat-spinner
      *ngIf="is_read_running"
      color="accent"
      diameter="20"></mat-spinner>

    <app-seller-details-navbar
      *ngIf="!is_read_running"
      (tab_change)="tab_change.emit($event)"></app-seller-details-navbar>

    <button
      (click)="$event.stopPropagation()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left"
      [matTooltip]="'Menu' | translate"
      [mat-menu-trigger-for]="sellers_actions_menu">
      <mat-icon> more_horiz </mat-icon>
    </button>

    <mat-menu #sellers_actions_menu="matMenu">
      <button
        (click)="onEditClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> create </mat-icon>
        <span> {{ 'SELLERS.EDIT_CTA' | translate }} </span>
      </button>

      <button
        (click)="onStoresClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> storefront </mat-icon>
        <span> {{ 'SHARED.TOOLBAR_STORES_LABEL' | translate }} </span>
      </button>

      <button
        (click)="onSetMfaClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> security_key </mat-icon>
        <span> {{ 'SELLERS.RESET_MFA_CTA' | translate }} </span>
      </button>

      <button
        (click)="onUnlockSellerClick(); $event.stopPropagation()"
        [disabled]="!seller?.blocked_at"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> lock_open</mat-icon>
        <span> {{ 'GENERAL.UNBLOCK_USER_CTA' | translate }} </span>
      </button>

      <button
        (click)="onInfoClick(); $event.stopPropagation()"
        [disabled]="!(seller?.is_confirmed && seller?.confirmed_by)"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> info </mat-icon>
        <span> {{ 'SELLERS.CONFIRM_USER_CTA' | translate }} </span>
      </button>
    </mat-menu>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
